import { AxiosInstance, isAxiosError } from "axios";
import { Boleto } from "./boleto";

export type Filter = {
    codigo_condominio: number
    bloco?: string
    codigo_unidade?: number
    data_de?: string
    data_ate?: string
}

export class InadimplentesRepository {
    constructor(
        private api: AxiosInstance
    ) {
    }

    async search({ codigo_condominio, ...params }: Filter): Promise<Boleto[]> {
        try {
            let {
                data
            } = await this.api.get<Boleto[]>(
                `condominios/${codigo_condominio}/inadimplentes`,
                { params }
            );
            return data
        } catch (error) {
            if (isAxiosError(error)) {
                throw new Error(error.response?.data?.error || "Não foi possível carregar os boletos")
            }
            throw new Error("Não foi possível carregar os boletos")
        }
    }
}